// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-body {
  display: flex;
  padding-top: 60px;
}
.profile-body .tab-content {
  background-color: #f5fbff;
  flex-grow: 1;
  max-width: "100%";
  overflow-x: clip;
  padding-left: 300px;
}
@media (max-width: 1400px) {
  .profile-body .tab-content {
    padding-left: 250px;
  }
}

.nav-item.active .nav-link {
  color: #00889b;
}

.nav-item .nav-link {
  color: #414b4f;
}
.nav-item .nav-link:hover {
  color: #00889b;
}`, "",{"version":3,"sources":["webpack://./src/components/common/LeftTabs.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,iBAAA;AADF;AAGE;EACE,yBCDc;EDEd,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAGI;EAPF;IAQI,mBAAA;EAAJ;AACF;;AAKE;EACE,cCRU;ADMd;;AAOE;EACE,cCJU;ADAd;AAKI;EACE,cChBQ;ADad","sourcesContent":["@import '../../styles/colors';\n\n.profile-body {\n  display: flex;\n  padding-top: 60px;\n  \n  .tab-content {\n    background-color: $page-background;\n    flex-grow: 1;\n    max-width: '100%';\n    overflow-x: clip;\n    padding-left: 300px;\n\n    @media (max-width: 1400px) {\n      padding-left: 250px;\n    }\n  }\n}\n\n.nav-item.active {\n  .nav-link {\n    color: $btn-primary;\n  }\n}\n\n.nav-item {\n  .nav-link {\n    color: $text-normal;\n    &:hover {\n      color: $btn-primary;\n    }\n  }\n}\n","$site-text: #00171f;\n$safe-list: #8e8e93;\n$trans-white: rgba(255, 255, 255, 0.5);\n$trans-grey: rgba(211, 211, 211, 0.5);\n$disabled-link: rgba(142, 142, 147, 0.15);\n$white: #ffffff;\n$page-background: #f5fbff;\n\n$link: #007ea7;\n$font-awesome-icon-color: #85a3ad;\n\n// Buttons\n$btn-color-white: #ffffff;\n$btn-primary: #00889b;\n$secondary: #9db6be;\n$favorite-star: #f9a825;\n\n// Forms\n$form-control-border: #e7edef;\n$form-color: #85a3ad;\n$form-error: #ef6360;\n\n//text color\n$text-normal: #414b4f;\n\n//primary\n$primary-color: #00889b;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
